/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [vp.ReportDetailResponse, (requestParams: vp.ReportsRequest) => void, () => void];

function useFetchSubscriptionDetail({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [params, setParams] = useState<vp.ReportsRequest>({ SubscriptionID: '' });
  const [response, setResponse] = useState<vp.ReportDetailResponse>({
    ErrorMessage: '',
    Success: false,
    AccountSubscriptionDetail: {
      ID: '',
      VIOAccounts_ID: '',
      USRUsers_ID: '',
      ReportName: '',
      Frequency: '',
      FromDate: '',
      ToDate: '',
      RecipientEmails: '',
      Description: '',
      IsActive: '',
      ScheduleType: '',
      DateFormat: '',
      DateAdded: '',
      LastModified: '',
      PaymentRails: {},
      AccountTransactionReports: {},
      AccountTransactionReportType: '',
      IncludeSubAccounts: false,
      IncludeGraph: false,
      DateRangeOption: '',
      FilterParams: {
        TransactionReportFailureReasons: [],
      },
    },
  });
  const [shouldSendRequest, setSendRequest] = useState(false);

  useEffect(() => {
    const sendRequest = async (requestParams: vp.ReportsRequest) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');
      const res = await api.fetchSubscriptionDetail(requestParams, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: vp.ReportsRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setSendRequest(false);
      setResponse({
        ErrorMessage: '',
        Success: false,
        AccountSubscriptionDetail: {
          ID: '',
          VIOAccounts_ID: '',
          USRUsers_ID: '',
          RecipientEmails: '',
          Frequency: '',
          FromDate: '',
          ToDate: '',
          ReportName: '',
          Description: '',
          IsActive: '',
          ScheduleType: '',
          DateFormat: '',
          DateAdded: '',
          LastModified: '',
          AccountTransactionReportType: '',
          IncludeSubAccounts: false,
          IncludeGraph: false,
          DateRangeOption: '',
          PaymentRails: {},
          AccountTransactionReports: {},
          FilterParams: {
            TransactionReportFailureReasons: [],
          },
        },
      });
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(useFetchSubscriptionDetail);
